import { uploadInstrumentQuestionVideo } from '@/features/instruments/infra/instrumentDraft.api'
import { ApiError } from '@/api/http/types'
import { validateVideoUploadFile } from '@/features/instruments/domain/videoSource'

const UPLOAD_UNAVAILABLE_MESSAGE =
  'Video upload is temporarily unavailable. Please try again later or contact your administrator.'

export function mapQuestionVideoUploadError(err: unknown): Error {
  if (err instanceof ApiError) {
    if (err.status === 503 || /S3_|MinIO|Object storage|not configured/i.test(err.message)) {
      return new Error(UPLOAD_UNAVAILABLE_MESSAGE)
    }
    return err
  }
  if (err instanceof Error) {
    if (/S3_|MinIO|Object storage|not configured/i.test(err.message)) {
      return new Error(UPLOAD_UNAVAILABLE_MESSAGE)
    }
    return err
  }
  return new Error('Video upload failed')
}

export async function uploadBuilderQuestionVideo(params: {
  campaignId?: string
  instrumentId: string
  questionId: string
  file: File
}): Promise<string> {
  if (!params.instrumentId) {
    throw new Error('Instrument is required to upload a video')
  }
  const fileErr = validateVideoUploadFile(params.file)
  if (fileErr) throw new Error(fileErr)
  try {
    const { videoUrl } = await uploadInstrumentQuestionVideo({
      campaignId: params.campaignId,
      instrumentId: params.instrumentId,
      questionId: params.questionId,
      file: params.file,
    })
    return videoUrl
  } catch (err: unknown) {
    throw mapQuestionVideoUploadError(err)
  }
}
